exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-image-preview{flex:1;min-height:0;overflow:auto;padding:20px;background:#f3f4f6}.document-image-preview img{display:block;max-width:100%;height:auto;margin:0 auto}", ""]);

// exports
